const getWeightedSize = (marketUnitRows) => {
  const result = marketUnitRows.reduce((acc, row) => acc + ((parseFloat(row.Size) || 0) * (row.UnitCount || 0)) / getTotalUnits(marketUnitRows), 0);
  return result ? result.toFixed(2) : 0;
};

const getWeightedRent = (marketUnitRows) => {
  const result = marketUnitRows.reduce((acc, row) => acc + ((parseFloat(row.RentPrice) || 0) * (row.UnitCount || 0)) / getTotalUnits(marketUnitRows), 0);
  return result ? result.toFixed(2) : 0;
};

const getWeightedRentPerSize = (marketUnitRows) => {
  const result = getWeightedRent(marketUnitRows) / getWeightedSize(marketUnitRows);
  return result ? result.toFixed(2) : 0;
};

const getTotalUnits = (marketUnitRows) => {
  return marketUnitRows.reduce((acc, row) => acc + parseInt(row.UnitCount || 0, 10), 0);
};

const getTotalVacantUnits = (marketUnitRows) => {
  return marketUnitRows.reduce((acc, row) => acc + parseInt(row.VacantUnitCount || 0, 10), 0);
};

const getWeightedOcuppancy = (marketUnitRows) => {
  const totalOcuppancy = marketUnitRows.reduce((acc, row) => {
    return row.Occupancy || row.Occupancy === 0 ? acc + (parseFloat(row.Occupancy) * (row.UnitCount || 0)) / getTotalUnitsWithOccupancy(marketUnitRows) : acc;
  }, 0);
  return totalOcuppancy && Number.isNaN(totalOcuppancy) ? '0%' : `${totalOcuppancy.toFixed(2)}%`;
};

const getTotalUnitsWithOccupancy = (marketUnitRows) => {
  return marketUnitRows.reduce((acc, row) => (row.Occupancy || row.Occupancy === 0 ? acc + parseInt(row.UnitCount || 0, 10) : acc), 0);
};

export default {
  getWeightedSize,
  getWeightedRent,
  getWeightedRentPerSize,
  getTotalUnits,
  getTotalVacantUnits,
  getWeightedOcuppancy,
  getTotalUnitsWithOccupancy,
};
